import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import SectionHead from './SectionHead';

/**
 * The FAQ block. Native <details>, exactly as the static pages used - no JS,
 * and open-by-keyboard for free.
 */
const Faq = props => {
  const { heading, items } = props;
  if (!items.length) {
    return null;
  }
  return (
    <section className="section-alt" id="faq" aria-labelledby="faq-title">
      <div className="container">
        <SectionHead id="faq-title" heading={heading} />
        <div className="faq">
          {items.map(item => (
            <details key={item.q}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

Faq.propTypes = {
  heading: string.isRequired,
  items: arrayOf(shape({ q: string, a: string })),
};
Faq.defaultProps = { items: [] };

export default Faq;
